import createAction from 'Store/utils/createAction';
const SELECT_PROPOSAL = 'SELECT_PROPOSAL';
const CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return createAction(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId: string) {
  return createAction(SELECT_PROPOSAL, {
    proposalId,
  });
}

export type SelectProposal = typeof selectProposal;
export { CLEAR_SELECTED_PROPOSAL, SELECT_PROPOSAL, selectProposal, clearSelectedProposal };
